import { Box, styled } from '@mui/material';

import { generateNewCase } from '#test';

import { NewCaseCard } from './NewCaseCard';

const PREFIX = 'TSMED-NewCaseCardPreview';

export const NewCaseCardPreviewClasses = {
  root: `${PREFIX}-root`,
} as const;

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 'inherit',
}));

export const NewCaseCardPreview = () => {
  const newCaseData = generateNewCase();

  return (
    <Root>
      <NewCaseCard
        data={newCaseData}
        width={260}
        sx={({ palette }) => ({
          transform: 'scale(0.75)',
          backgroundColor: palette.mapBlue[900],
          minWidth: 260,
        })}
      />
    </Root>
  );
};
